import { render } from "./ModalTransferBtc.vue?vue&type=template&id=0e58a2be&scoped=true&ts=true"
import script from "./ModalTransferBtc.vue?vue&type=script&lang=ts"
export * from "./ModalTransferBtc.vue?vue&type=script&lang=ts"

import "./ModalTransferBtc.vue?vue&type=style&index=0&id=0e58a2be&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e58a2be"]])

export default __exports__